/**
 * View Slice
 *
 * State and actions for view mode and task selection.
 */

import type { StateCreator } from 'zustand';
import type { ViewMode } from '@/types';
import type { AppStore, ViewSlice } from '../types';

export const createViewSlice: StateCreator<AppStore, [], [], ViewSlice> = (set, get) => ({
  viewMode: 'list',
  selectedTaskId: null,

  setViewMode: (mode: ViewMode) => {
    const viewModesWithoutPathFilters: ViewMode[] = ['inbox', 'team', 'timesheet', 'projects', 'deviations'];
    if (viewModesWithoutPathFilters.includes(mode)) {
      const currentFilters = get().filters;
      if (currentFilters.path !== null) {
        set({
          viewMode: mode,
          filters: { ...currentFilters, path: null },
          selectedTaskId: null,
          currentItemType: null,
          currentDocument: null,
          currentChat: null,
          currentVoiceChannel: null,
          currentSpreadsheet: null,
          currentPresentation: null,
        });
        return;
      }
    }
    set({ viewMode: mode });
  },

  setSelectedTaskId: (id) => set({ selectedTaskId: id }),
});
